import { get, post,put,remove } from '@/utils/http.js'
export const listMenu = (data) => get('/system/menu/list',data);
export const getMenu = (menuId) => get('/system/menu/' + menuId);
export const treeselect = (menuId) => get('/system/menu/treeselect?platformNum=2');
export const roleMenuTreeselect = (roleId) => get('/system/menu/roleMenuTreeselect?roleId=' + roleId+'&platformNum=2');
export const addMenu = (data) => post('/system/menu',{...data,platformNum:2});
export const updateMenu = (data) => put('/system/menu',{...data,platformNum:2});
export const delMenu = (menuId) => remove( '/system/menu/' + menuId);

// 查询菜单列表
// export function listMenu(query) {
//   return request({
//     url: '/system/menu/list',
//     method: 'get',
//     params: query
//   })
// }

// 查询菜单详细
// export function getMenu(menuId) {
//   return request({
//     url: '/system/menu/' + menuId,
//     method: 'get'
//   })
// }

// 查询菜单下拉树结构
// export function treeselect() {
//   return request({
//     url: '/system/menu/treeselect',
//     method: 'get'
//   })
// }

// 根据角色ID查询菜单下拉树结构
// export function roleMenuTreeselect(roleId) {
//   return request({
//     url: '/system/menu/roleroleMenuTreeselect/' + roleId,
//     method: 'get'
//   })
// }

// 新增菜单
// export function addMenu(data) {
//   return request({
//     url: '/system/menu',
//     method: 'post',
//     data: data
//   })
// }

// 修改菜单
// export function updateMenu(data) {
//   return request({
//     url: '/system/menu',
//     method: 'put',
//     data: data
//   })
// }

// 删除菜单
// export function delMenu(menuId) {
//   return request({
//     url: '/system/menu/' + menuId,
//     method: 'delete'
//   })
// }